var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"imageEl",staticClass:"image-placeholder image-placeholder--is-animate",class:[{'image-placeholder--mod-fixed': _vm.fixed},{'image-placeholder--is-loaded': _vm.isLoaded}],style:(_vm.bgImage),on:{"contextmenu":function($event){$event.preventDefault();return _vm.preventRightClick($event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-729a1afc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ModuleImage/components/ImagePlaceholder/ImagePlaceholder.vue
// module id = null
// module chunks = 